import { api as locationPageApi } from '../locationPageActions.js';
import * as rollsService from '../../../services/Rolls/rollsService';
import {gridsNames} from '../../../enums/gridsNames';
import * as gridActionsHelper from 'infrastructure/js/components/Grid/Utils/gridActionsHelper';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import {enumTypes, getEnumValue} from '../../../utils/enumHelper';

const gridActions = gridActionsHelper.getGridActions(gridsNames.LOCATION_ASSET_ROLLS, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function(dispatch, getState) {
    let locationId = locationPageApi.getLocationId(dispatch, getState)();
    let locationType = locationPageApi.getLocationType(dispatch, getState)();

    if (locationType === getEnumValue(enumTypes.LOCATION_TYPE)('OUTGOING_SHIPMENTS') ) {
      return rollsService.getShippedRollsByStationId(locationId, query);
    }
    else if (locationType === getEnumValue(enumTypes.LOCATION_TYPE)('INCOMING_SHIPMENTS') ) {
      return rollsService.getReceivingRollsByStationId(locationId, query);
    }
    else if (locationType === getEnumValue(enumTypes.LOCATION_TYPE)('SHIPPING_PREPARATION') ) {
      return rollsService.getShippingPreparaionRollsByStationId(locationId, query);
    }
    return rollsService.getRollsDataByStationId(locationId, query);
  }
}

function _convertToRowData(rows, serverTimeSeconds){
  let rolls = rows.map((obj, index) => {
    if(obj.expirationDate){
      obj.m_ExpirationDaysLeft =  DateTimeHelper.GetDifferenceInDays(obj.expirationDate.value, serverTimeSeconds);
    }

    if(obj.lastOperation){
      obj.lastOperation.m_time = DateTimeHelper.FormatDateObjectToRelativeTime(obj.lastOperation?.createdDate, serverTimeSeconds);
    }
    
    return obj;
  });

  return rolls;
};

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
